(() => {
  if (customElements.get("card-carousel")) return;

  class CardCarousel extends HTMLElement {
    constructor() {
      super();

      this.initSwiper = this.initSwiper.bind(this);
    }

    connectedCallback() {
      if (window.Swiper) {
        this.initSwiper();
      } else {
        document.addEventListener("DOMContentLoaded", this.initSwiper, { once: true });
      }
    }

    disconnectedCallback() {
      document.removeEventListener("DOMContentLoaded", this.initSwiper);
      this.swiper?.destroy(true, true);
      this.swiper = null;
    }

    initSwiper() {
      const swiperEl = this.querySelector("[data-card-carousel-swiper]");
      if (!swiperEl || !window.Swiper || this.swiper) return;

      this.swiper = new Swiper(swiperEl, {
        slidesPerView: "auto",
        spaceBetween: 16,
        grabCursor: true,
        watchOverflow: true,
        pagination: {
          el: this.querySelector("[data-card-carousel-pagination]"),
          clickable: true,
        },
      });
    }
  }

  customElements.define("card-carousel", CardCarousel);
})();
